<template>
    <div class="p-5 border rounded d-flex flex-column" :class="{'border-warning': isMissingConfigs}">
        <div class="d-flex flex-row">
            <div class="flex-grow-1 d-flex flex-row align-items-center">
                <div v-if="integration.icon_url" class="mr-2 d-flex flex-column justify-content-center">
                    <img :src="integration.icon_url" :alt="integration.name" style="height: 18px; width: 18px;">
                </div>
                <div class="d-flex flex-column justify-content-center font-weight-bold text-xl pt-1">
                    {{ integration.name }}
                </div>
            </div>
            <div class="d-flex flex-column justify-content-center">
                <div class="d-flex flex-row justify-content-end gap-1">
                    <div v-if="!integration.visible || integration.enabled"
                         title="This integration is not visible for other users.">
                        <div class="badge bg-light-secondary text-muted user-select-none">
                            <i class="fas fa-eye-slash"/>
                            Hidden
                        </div>
                    </div>
                    <div>
                        <div class="badge bg-light-warning text-warning user-select-none"
                             v-if="isMissingConfigs"
                        >
                            <i class="fas fa-exclamation-triangle"/>
<!--                            {{ __('integrations.missing_config') }}-->
                        </div>
                        <div class="badge bg-light-success text-success user-select-none"
                             v-else-if="integration.state === 'enabled'"
                        >
                            <i class="fas fa-check"/>
                            {{ __('general.active') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3 pt-3 border-top flex-grow-1 d-flex flex-column">
            <div class="text-muted flex-grow-1">
                {{ integration.description || __('integrations.no_description') }}
            </div>
            <div class="mt-3">
                <a v-if="integration.enabled" :href="$route('integration.show', [integration.code])"
                   class="btn btn-sm btn-block btn-default btn-hover-primary">
                    <i class="fas fa-cog"/>
                    {{ __('general.settings') }}
                </a>
                <a v-if="!integration.enabled"
                   class="btn btn-xs btn-light-primary" @click="enable">
                    <i class="fas fa-arrow-circle-right"/>
                    {{ __('actions.activate') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Badge from "@components/Badge.vue";
import {IntegrationState} from "@generated/integrationState";

export default {
    components: {Badge},

    props: {
        integration: {
            type: Object,
            default() {
                return {
                    name: null,
                    code: null,
                    short_name: null,
                    enabled: null,
                    abilities: [],
                }
            }
        },
    },

    methods: {
        enable() {
            if (this.integration.disclaimers.length > 0) {
                let vue = this;
                Swal.fire({
                    title: __('general.hint'),
                    text: this.integration.disclaimers.join('\n'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-primary m-0',
                    confirmButtonText: __('actions.consent'),
                    cancelButtonText: __('actions.abort'),
                }).then(function (result) {
                    if (result.value) {
                        vue.submitEnable();
                    }
                });
            } else {
                this.submitEnable();
            }
        },

        submitEnable() {
            this.$inertia.visit(this.$route('integration.enable', {integration: this.integration.code}));
        },
    },

    computed:{
        isMissingConfigs(){
            return this.integration.state === IntegrationState.MissingConfig;
        }
    }
};
</script>
